// extracted by mini-css-extract-plugin
export default {"skillsBlock":"Skills_skillsBlock__CZyZz","skillContainer":"Skills_skillContainer__LqSSJ","skills":"Skills_skills__276A3"};